exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {\n    height: 100%;\n    margin: 0;\n    font-family: \"Raleway\", sans-serif;\n    background-color: white;\n    font-size: 12px;\n}\n\nhtml * {\n    box-sizing: border-box;\n}\n\n#root {\n    height: 100%;\n}\n", ""]);

// exports
